import Vue from 'vue'
import Vuex from 'vuex'
//import vuexCache from 'vuex-cache'
import auth from './modules/auth'
import categories from './modules/categories'
import inbox from './modules/inbox'

Vue.use(Vuex);

export default new Vuex.Store({

    //plugins: [vuexCache],

    modules: {
        auth,
        categories,
        inbox,
    }
})


// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js